<template>
  <tr class="clinic-treatment">
    <td class="clinic-treatment__date">{{ pretty_date }}</td>
    <td v-if="showclinic" class="clinic-treatment__clinic">{{ clinic_name }}</td>
    <td class="clinic-treatment__doctor">{{ doctor_name }}</td>
    <td class="clinic-treatment__doctor">{{ derived_by }}</td>
    <td class="clinic-treatment__treatment">
      {{ treatment_name }}
    </td>
    <td class="clinic-treatment__type">
      {{ product_type }}
    </td>
    <td class="clinic-treatment__category">
      {{ category_name }}
    </td>
    <td class="clinic-treatment__customer">
      <a target="_blank" :href="customer_link">{{ customer_name }}</a>
    </td>
    <td class="clinic-treatment__price">{{ treatment_price }}</td>
    <td v-if="comissions_enabled" class="clinic-treatment__price">{{ comission }}</td>
    <td class="clinic-treatment__done">{{ done }}</td>
    <td class="clinic-treatment__paid">{{ paid }}</td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    treatment: { required: true },
    clinics: { default: null },
    doctors: { default: null },
    showpaid: { default: null },
    categories: { default: null },
    orderby: { default: null },
    showclinic: { default: false },
    core: { default: false },
  },
  computed: {
    comissions_enabled() {
      return Boolean(this.clinic && this.clinic.config && this.clinic.config.products_enable_comissions);
    },
    treatment_price() {
      return WabiDent.fmtMoney(this.treatment.price);
    },
    comission() {
      if (this.treatment.comission) {
        return WabiDent.fmtMoney(this.treatment.comission);
      }
      return '';
    },
    product_type() {
      if (!this.treatment.product) return "";
      return this.treatment.product.type == "product" ? "Producto" : "Ttto";
    },
    category_name() {
      if (!this.categories || !this.treatment.product.product_category_id)
        return "";

      return this.categories[this.treatment.product.product_category_id];
    },
    customer_name() {
      if (!this.treatment.customer) return "";
      return this.customer.full_name;
    },
    customer_link() {
      if (!this.treatment.customer) return "";
      return `/customer/${this.treatment.customer.id}/edit`;
    },
    pretty_date() {
      let d = this.treatment.created_at;
      switch (this.orderby) {
        case "done_at":
          d = this.treatment.done_at;
          break;
        case "paid_at":
          d = this.treatment.paid_at;
          break;
      }
      if (d) {
        return moment(d).toDate().toLocaleDateString();
      }
      return "-";
    },
    doctor_name() {
      if (!this.doctors) return "";
      let doc = this.doctors.find((doc) => {
        return doc.doctor.id == this.treatment.doctor_id;
      });

      if (!doc) return "";
      return doc.name;
    },
    derived_by() {
      if (!this.doctors) return "";
      let doc = this.doctors.find((doc) => {
        return doc.doctor.id == this.treatment.derived_by;
      });

      if (!doc) return "";
      return doc.name;
    },
    treatment_name() {
      return this.treatment.full_name;
    },
    customer_name() {
      if (!this.treatment.customer) return "";
      return this.treatment.customer.full_name;
    },
    clinic_name() {
      if (!this.clinics) return "";
      return this.clinics[this.treatment.clinic_id] || "";
    },
    done() {
      if (this.treatment.status == "done") return "Sí";
      return "No";
    },
    paid() {
      if (this.treatment.is_paid) return "Sí";
      return "No";
    },
    price() {
      if (this.treatment.price) {
        return window.WabiDent.fmtMoney(this.treatment.price);
      }
      return "";
    },
    ...mapGetters(['clinic'])
  },
};
</script>

<style lang="scss"></style>
